export default __webpack_public_path__ + "8854095a8ab6acaa7735f73eb7c209b6.otf";